
import { ORDER_MENU_ITEM } from '@/utils/EndPoint'
import Vue from 'vue'
export default Vue.extend({
  name: ORDER_MENU_ITEM,
  props: ['menu']
})
